import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

export const ConfirmDialog = ({
  open,
  onOpenChange,
  title = "¿Desea realmente realizar esta acción?",
  description,
  confirmText = "Sí, continuar",
  cancelText = "Cancelar",
  onConfirm,
  loading = false,
  destructive = true,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-2xl" data-testid="confirm-dialog">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className={`h-11 w-11 rounded-xl flex items-center justify-center flex-shrink-0 ${destructive ? "bg-red-50 text-red-500" : "bg-amber-50 text-amber-500"}`}>
              <AlertTriangle size={22} />
            </div>
            <div className="min-w-0">
              <DialogTitle>{title}</DialogTitle>
              {description && <DialogDescription className="mt-1">{description}</DialogDescription>}
            </div>
          </div>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} className="rounded-xl" data-testid="confirm-cancel-btn">{cancelText}</Button>
          <Button
            onClick={onConfirm}
            disabled={loading}
            data-testid="confirm-accept-btn"
            className={`rounded-xl ${destructive ? "bg-red-600 hover:bg-red-700" : "bg-emerald-600 hover:bg-emerald-700"}`}
          >
            {loading ? "Procesando..." : confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmDialog;
